"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("./helpers");
function queryParameter(criteria, services) {
    var urlQueryParams = services.browserEnvironment.urlQueryParams;
    var cr = __spreadArray([], criteria, true);
    var parseResults = cr.map(function (_a) {
        var key = _a.key, condition = _a.condition, connector = _a.connector, values = _a.values;
        var result = false;
        if (condition === 'exist') {
            result = urlQueryParams.hasOwnProperty(key);
        }
        else if (condition === 'notExist') {
            result = !urlQueryParams.hasOwnProperty(key);
        }
        else {
            result = (0, helpers_1.parseStringCondition)(condition, urlQueryParams[key], values);
        }
        return { connector: connector, result: result };
    });
    return (0, helpers_1.mergeParsingLogicalResult)(parseResults);
}
exports.default = queryParameter;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicXVlcnlQYXJhbWV0ZXIuanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsic3JjL2xpYi9zZXJ2aWNlcy90YXJnZXRzL3F1ZXJ5UGFyYW1ldGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0FBRUEscUNBQTJFO0FBSzNFLFNBQXdCLGNBQWMsQ0FBRSxRQUFrQyxFQUFFLFFBQXNCO0lBQ2hFLElBQUEsY0FBYyxHQUFPLFFBQVEsa0NBQWYsQ0FBZTtJQUMzRCxJQUFNLEVBQUUsR0FBRyxrQkFBSSxRQUFRLE9BQWUsQ0FBQTtJQUN0QyxJQUFNLFlBQVksR0FBRyxFQUFFLENBQUMsR0FBRyxDQUFDLFVBQUMsRUFBcUM7WUFBbkMsR0FBRyxTQUFBLEVBQUUsU0FBUyxlQUFBLEVBQUUsU0FBUyxlQUFBLEVBQUUsTUFBTSxZQUFBO1FBQzVELElBQUksTUFBTSxHQUFHLEtBQUssQ0FBQTtRQUVsQixJQUFJLFNBQVMsS0FBSyxPQUFPLEVBQUU7WUFDdkIsTUFBTSxHQUFHLGNBQWMsQ0FBQyxjQUFjLENBQUMsR0FBRyxDQUFDLENBQUE7U0FDOUM7YUFBTSxJQUFJLFNBQVMsS0FBSyxVQUFVLEVBQUU7WUFDakMsTUFBTSxHQUFHLENBQUMsY0FBYyxDQUFDLGNBQWMsQ0FBQyxHQUFHLENBQUMsQ0FBQTtTQUMvQzthQUFNO1lBQ0gsTUFBTSxHQUFHLElBQUEsOEJBQW9CLEVBQUMsU0FBUyxFQUFFLGNBQWMsQ0FBQyxHQUFHLENBQUMsRUFBRSxNQUFrQixDQUFDLENBQUE7U0FDcEY7UUFFRCxPQUFPLEVBQUUsU0FBUyxXQUFBLEVBQUUsTUFBTSxRQUFBLEVBQUUsQ0FBQTtJQUNoQyxDQUFDLENBQUMsQ0FBQTtJQUVGLE9BQU8sSUFBQSxtQ0FBeUIsRUFBQyxZQUFZLENBQUMsQ0FBQTtBQUNsRCxDQUFDO0FBbEJELGlDQWtCQyJ9